import React, { FC } from 'react';

import { PlayButton } from '@/scenarios/legacy-player/components/feature-player/ui/skin/play-button/component';
import { useIsWaitingUserPlay } from '@/scenarios/legacy-player/hooks/useIsWaitingUserPlay';
import { usePlayingState } from '@/scenarios/legacy-player/hooks/usePlayingState';
import { PlayingState } from '@/scenarios/legacy-player/types/instance';

interface SportPlayButtonProps {
    className?: string;
}

export const SportPlayButton: FC<SportPlayButtonProps> = ({ className }) => {
    const isWaitingUserPlay = useIsWaitingUserPlay();
    const { playingState } = usePlayingState();

    return isWaitingUserPlay || playingState === PlayingState.pause ? (
        <PlayButton className={className} isChannel />
    ) : null;
};
